import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductDto } from "../services/generated.schemas";

export type CartItem = {
  product: ProductDto;
  quantity: number;
  collectionTitle: string;
  variantIdx: number;
};

export interface CartState {
  items: CartItem[];
}

const initialState: CartState = {
  items: [],
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItem: (state, action: PayloadAction<CartItem>) => {
      const item = action.payload;
      const existing = state.items.find(
        (i) =>
          i.product.id === item.product.id && i.variantIdx === item.variantIdx,
      );

      if (!existing) {
        state.items.push(item);
      }
    },

    removeItem: (
      state,
      action: PayloadAction<{ id: string; variantIdx: number }>,
    ) => {
      const { id, variantIdx } = action.payload;
      state.items = state.items.filter(
        (i) => !(i.product.id === id && i.variantIdx === variantIdx),
      );
    },

    setQuantity: (
      state,
      action: PayloadAction<{
        id: string;
        variantIdx: number;
        newQuantity: number;
      }>,
    ) => {
      const { id, variantIdx, newQuantity } = action.payload;
      const product = state.items.find(
        (item) => item.product.id === id && item.variantIdx === variantIdx,
      );

      if (product) {
        product.quantity = newQuantity;
      }
    },

    clearCart: (state) => {
      state.items = [];
    },
  },
});

export const { addItem, removeItem, clearCart, setQuantity } =
  cartSlice.actions;

export default cartSlice.reducer;
